import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a8a296f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row g-4 mb-8 d-flex align-items-center" }
const _hoisted_2 = { class: "col-sm-3 col-md-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  style: {"color":"var(--cor_texto_1)","font-size":"18px"}
}, "Social", -1))
const _hoisted_4 = {
  key: 0,
  style: {"color":"var(--cor_texto_1)"}
}
const _hoisted_5 = {
  key: 1,
  style: {"color":"var(--cor_texto_1)"}
}
const _hoisted_6 = { class: "col-sm-9 col-md-10" }
const _hoisted_7 = { class: "row g-4 d-flex align-items-center" }
const _hoisted_8 = {
  id: "container_inputSearch",
  class: "col-9 col-sm-10 col-md-7 col-lg-8 col-xxl-9 justify-content-end align-items-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-search",
  id: "container_ISearch",
  "aria-hidden": "true",
  style: {"position":"absolute","cursor":"text","right":"1.5rem","top":"0.8rem","margin":"0","padding":"0","font-size":"1.5rem","color":"red"}
}, null, -1))
const _hoisted_10 = { class: "col-3 col-sm-2 col-md-5 col-lg-4 col-xxl-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true",
  style: {"margin":"0","padding":"0","font-size":"1.5rem","color":"white"}
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ms-4 d-none d-md-inline-flex",
  style: {"color":"white"}
}, "Criar uma postagem", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M84.8782 33.0973C84.1128 40.3225 79.7411 47.3492 71.7791 52.347C60.3986 59.7351 45.3096 61.3992 32.8031 59.1895C28.3518 63.3677 23.7432 65.6184 19.4251 66.6866C20.6794 68.8989 22.2793 70.8951 24.0327 72.6562C25.7844 80.5477 15 89.5579 15 89.5579C18.0355 91.3222 33.7073 97.4204 47.8031 84.1895C60.3096 86.3993 75.3986 84.7351 86.7791 77.347C104.378 66.2998 104.436 45.34 86.7791 34.2347C86.164 33.8352 85.5296 33.4563 84.8782 33.0973Z",
    fill: "var(--cor_texto_1)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.4",
    d: "M67.5568 8.71653C56.8721 1.90887 39.9999 1.59551 29.9999 3.52404C27.1366 4.07624 22.6069 5.10586 18 7.38123C13.7202 9.49501 8.87941 12.8593 5.99999 17.0242C-2 28.5957 2.19722 37.9722 8.50137 44.1825C10.15 51.467 0 59.784 0 59.784C2.85694 61.4126 17.6069 67.0417 30.8735 54.8286C42.6443 56.8684 56.8457 55.3322 67.5568 48.5125C84.1206 38.3151 84.1748 18.9675 67.5568 8.71653Z",
    fill: "var(--cor_texto_1)"
  })
], -1))
const _hoisted_15 = {
  key: 2,
  class: "posts gap-5"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dropdown btn btn-sm p-0" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-ellipsis-v",
    "aria-hidden": "true",
    style: {"color":"var(--cor_btn_1)"}
  })
], -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-7 d-flex align-items-start" }
const _hoisted_19 = { class: "d-flex me-2" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  src: "images/perfil-generico.png",
  alt: "imagem do usuário"
}
const _hoisted_22 = {
  key: 0,
  style: {"color":"var(--cor_texto_2)"}
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "col-5 d-flex flex-column" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"color":"var(--cor_texto_2)"},
  class: "mb-2"
}, "Enviado para", -1))
const _hoisted_27 = { class: "row g-4" }
const _hoisted_28 = { class: "col-lg-6 mb-0 pb-0" }
const _hoisted_29 = {
  key: 0,
  class: "w-100"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 1,
  controls: "",
  class: "w-100",
  style: {"margin-bottom":"-6.5px"}
}
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "col-lg-6" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { style: {"opacity":"0.5","font-size":"1rem"} }
const _hoisted_36 = {
  key: 1,
  class: "col-12"
}
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = {
  class: "mt-4",
  style: {"color":"var(--cor_texto_2)"}
}
const _hoisted_39 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_40 = { class: "modal-dialog" }
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = { class: "modal-header" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title text-danger",
  id: "exampleModalLabel"
}, "Excluir Postagem", -1))
const _hoisted_44 = {
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "refModalDel",
  style: {"background-color":"transparent","border":"none"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1.8rem","font-weight":"600","margin-bottom":"1rem","color":"var(--cor_texto_2)"} }, "x", -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" A postagem selecionada será excluida."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Deseja excluir ? ")
  ])
], -1))
const _hoisted_48 = { class: "modal-footer" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-sm background_btn_1_opct",
  "data-bs-dismiss": "modal"
}, "Cancelar", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-alt",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_CampEmptyListFeedbackV2 = _resolveComponent("CampEmptyListFeedbackV2")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_CampDropdownHeader = _resolveComponent("CampDropdownHeader")!
  const _component_CampDropdownItem = _resolveComponent("CampDropdownItem")!
  const _component_CampDropdown = _resolveComponent("CampDropdown")!
  const _component_modalFilterSenderPosts = _resolveComponent("modalFilterSenderPosts")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.postStore.getStartDate && _ctx.postStore.getEndDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " De " + _toDisplayString(_ctx.moment(_ctx.postStore.getStartDate).format('DD/MM/YY')) + " até " + _toDisplayString(_ctx.moment(_ctx.postStore.getEndDate).format('DD/MM/YY')), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, " Todo o período "))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.filterDom,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterDom) = $event)),
              placeholder: "Filtrar por titulo",
              type: "text",
              style: {"height":"3.3rem"}
            }, null, 8, ["modelValue"]),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModalSelectCompetitor())),
              class: "btn background_btn_1 w-100"
            }, _hoisted_13)
          ])
        ])
      ])
    ]),
    (!_ctx.loading && !_ctx.posts?.filter(elem => elem.title.toLowerCase().includes(_ctx.filterDom.toLowerCase())).length)
      ? (_openBlock(), _createBlock(_component_CampEmptyListFeedbackV2, {
          key: 0,
          id: "companies-icon-empty-list-feedback"
        }, {
          icon: _withCtx(() => [
            _hoisted_14
          ]),
          message: _withCtx(() => [
            _createTextVNode("Não há nada para mostrar")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_el_skeleton, {
          key: 1,
          rows: 5,
          animated: ""
        }))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.posts?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts?.filter(elem => elem.title.toLowerCase().includes(_ctx.filterDom.toLowerCase())), (post) => {
            return (_openBlock(), _createElementBlock("article", {
              class: "card p-4",
              key: post.id
            }, [
              _createVNode(_component_CampDropdown, { style: {"position":"absolute","right":"1rem"} }, {
                button: _withCtx(() => [
                  _hoisted_16
                ]),
                header: _withCtx(() => [
                  _createVNode(_component_CampDropdownHeader, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" Mais opções ")
                    ]),
                    _: 1
                  })
                ]),
                list: _withCtx(() => [
                  _createVNode(_component_CampDropdownItem, {
                    onClick: ($event: any) => (_ctx.openModalSelectCompetitor(true, post))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Editar ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_CampDropdownItem, {
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#exampleModal",
                    onClick: ($event: any) => (_ctx.postDeleted = post)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Excluir ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("header", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    (post.url_avatar)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: post.url_avatar,
                          alt: "imagem padrão do usuário"
                        }, null, 8, _hoisted_20))
                      : (_openBlock(), _createElementBlock("img", _hoisted_21))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", null, _toDisplayString(post.title), 1),
                    (!post.id_company && !post.id_store)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(post.description), 1))
                      : _createCommentVNode("", true),
                    (post.id_company)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, "Companhia"))
                      : _createCommentVNode("", true),
                    (post.id_store)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_24, "Loja"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("strong", null, _toDisplayString(post.send_to? post.count + ' ' + _ctx.makePlural(post.send_to, post.count): post.count + ' ' + "Todos"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                (post.url_media)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_28, [
                        (post.url_media && post.url_media.includes('/image'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _createElementVNode("img", {
                                src: post.url_media,
                                style: {"width":"100%","object-fit":"contain","border":"1px solid #e1e1e1"},
                                class: "rounded-2"
                              }, null, 8, _hoisted_30)
                            ]))
                          : _createCommentVNode("", true),
                        (post.url_media && post.url_media.includes('/video'))
                          ? (_openBlock(), _createElementBlock("video", _hoisted_31, [
                              _createElementVNode("source", {
                                src: post.url_media
                              }, null, 8, _hoisted_32),
                              _createTextVNode(" Seu navegador não suporta o elemento de vídeo. ")
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", {
                          innerHTML: post.message
                        }, null, 8, _hoisted_34),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.moment(post.send_date).format('DD/MM/YY - HH:mm')), 1)
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("div", {
                        innerHTML: post.message
                      }, null, 8, _hoisted_37),
                      _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.moment(post.send_date).format('DD/MM/YY - HH:mm')), 1)
                    ]))
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_modalFilterSenderPosts, {
      isChangeProps: _ctx.whatchProps,
      postSelectedEdit: _ctx.postSelected,
      onGetPosts: _ctx.getPosts,
      onCloseModal: _ctx.closeModal,
      onCloseModalTeste: _ctx.closeModalTeste,
      count: _ctx.count
    }, null, 8, ["isChangeProps", "postSelectedEdit", "onGetPosts", "onCloseModal", "onCloseModalTeste", "count"]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("button", _hoisted_44, _hoisted_46, 512)
          ]),
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-danger",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deletePost(_ctx.postDeleted?.id))),
              "data-bs-dismiss": "modal"
            }, [
              _hoisted_50,
              _createTextVNode(" Excluir ")
            ])
          ])
        ])
      ])
    ])
  ]))
}